import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { PortalSpinner } from 'components/PortalSpinner'
import { ConversationActions } from 'store/actions'
import Item from './Item'
import { connect } from 'react-redux'
import InfiniteScroll from 'react-infinite-scroll-component'
import toast from 'react-hot-toast'
import Filters from 'components/Conversation/Filters'

let enhancer = connect(null, { ...ConversationActions })

function List({ getConversations }) {
  const [searchParams, setSearchParams] = useSearchParams()
  const typeParam = searchParams.get('workflow_type')

  const initialParams = {
    q: { title_cont: "", workflow_type: typeParam },
    page: 1,
    items: 20
  }

  const [conversations, setConversations] = useState(null)
  const [pageEnd, setPageEnd] = useState(false)
  const [params, setParams] = useState(initialParams)

  async function loadConversations(_params = initialParams) {
    if (_params.page === 1) setConversations(null)
    try {
      let { data: _data = [], pagy, stats } = await getConversations(_params)
      setConversations({
        data: _params.page == 1 ? _data : [...(conversations?.data ?? []), ..._data],
        stats,
      })
      setParams(_params)
      setPageEnd(!pagy?.next)
    } catch (error: any) {
      toast.error(error.errors || 'Failed to load conversations')
    }
  }

  useEffect(() => {
    loadConversations()
  }, [])

  const handleSearch = (query: string) => {
    loadConversations({
      ...initialParams,
      q: {
        ...params.q,
        title_cont: query,
      },
    })
  }

  const handleFilterChange = (type) => {
    const newSearchParams = new URLSearchParams(searchParams)

    if (type)
      newSearchParams.set('workflow_type', type)
    else
      newSearchParams.delete('workflow_type')
    setSearchParams(newSearchParams, { replace: true })

    loadConversations({
      ...initialParams,
      q: {
        title_cont: params.q.title_cont,
        workflow_type: type,
      },
    })
  }

  const loadMore = () => {
    loadConversations({ ...params, page: params.page + 1 })
  }

  return (
    <div className="flex flex-col flex-1 min-h-0">
      <div className="p-2">
        <input
          type="text"
          placeholder="Search conversations..."
          defaultValue=""
          onChange={e => handleSearch(e.target.value)}
          className="input input-bordered input-sm w-full"
        />
      </div>

      <Filters
        activeTab={params.q.workflow_type}
        onChange={handleFilterChange}
        stats={conversations?.stats}
        loading={conversations === null}
      />

      {conversations === null ? (
        <PortalSpinner size={6} />
      ) : (
        <div id="conversation-list-scroll" className="flex-1 overflow-y-auto">
          <InfiniteScroll
            dataLength={conversations.data.length}
            next={loadMore}
            hasMore={!pageEnd}
            loader={<PortalSpinner padding="py-3" size={6} />}
            scrollableTarget="conversation-list-scroll"
            className="flex flex-col divide-y divide-base-200"
          >
            {conversations.data.length === 0 ? (
              <div className="py-12 text-center text-sm text-base-content/40">
                No conversations found.
              </div>
            ) : (
              conversations.data.map((item: any) => (
                <Item key={`conversation-${item.id}`} item={item} />
              ))
            )}
          </InfiniteScroll>
        </div>
      )}
    </div>
  )
}

export default enhancer(List)
